export default {  
  title: 'Dashboard EMP',  
  loginPageName: 'Masuk',
  logoutTip: 'Logout, apakah Anda ingin lanjutkan?',  
  submitText: 'Submit',  
  cancelText: 'Cancel',  
  search: 'Silakan masukkan konten yang ingin Anda cari',  
  menuTip: 'Menu tidak ditemukan',  
  common: {  
    condition: 'Kondisi',  
    display: 'Tampilkan',  
    hide: 'Sembunyikan',  
  },  
  tip: {  
    select: 'Silakan pilih',  
    input: 'Silakan masukkan',  
  },  
  upload: {  
    upload: 'Klik untuk upload',  
    tip: 'Seret file ke sini, atau',  
  },  
  date: {  
    start: 'Tanggal Mulai',  
    end: 'Tanggal Akhir',  
    t: 'Hari Ini',  
    y: 'Kemarin',  
    n: '7 Hari Terakhir',  
    a: 'Semua',  
  },  
  form: {  
    printBtn: 'Print',  
    mockBtn: 'Mock',  
    submitBtn: 'Submit',  
    emptyBtn: 'Kosongkan Semua',  
  },  
  crud: {  
    filter: {  
      addBtn: 'Tambahkan Kondisi',  
      clearBtn: 'Hapus Data',  
      resetBtn: 'Reset Kondisi',  
      cancelBtn: 'Batal',  
      submitBtn: 'Submit',  
    },  
    column: {  
      name: 'Nama Kolom',  
      hide: 'Sembunyikan',  
      fixed: 'Tetap',  
      filters: 'Filter',  
      sortable: 'Dapat Disortir',  
      index: 'Indeks',  
      width: 'Lebar',  
    },  
    tipStartTitle: 'Tabel ini memilih',  
    tipEndTitle: 'Item',  
    editTitle: 'Edit',  
    copyTitle: 'Copy',  
    addTitle: 'Add',  
    viewTitle: 'View',  
    filterTitle: 'Filter Kondisi',  
    showTitle: 'Tampilkan/Sembunyikan Kolom',  
    menu: 'Aksi',  
    addBtn: 'Add',  
    show: 'Tampilkan',  
    hide: 'Sembunyikan',  
    open: 'Membuka',  
    shrink: 'Memperkecil',  
    printBtn: 'Print',  
    excelBtn: 'Export',  
    updateBtn: 'Update',  
    cancelBtn: 'Batal',  
    searchBtn: 'Search',  
    emptyBtn: 'Kosongkan Semua',  
    menuBtn: 'Fungsi',  
    saveBtn: 'Save',  
    viewBtn: 'View',  
    editBtn: 'Edit',  
    copyBtn: 'Copy',  
    delBtn: 'Delete',  
  },  
  login: {  
    loginHeader: 'Masuk',
    loginAcc: 'Akun',
    loginAcctx: 'Silakan masukkan Nama Akun Anda',
    loginPass: 'Masukkan kata sandi Anda',
    loginPasstx: 'Silakan masukkan kata sandi Anda',
    loginCode: 'Silakan masukkan kode',
    loginCodetx: 'Masukkan kode verifikasi',
    loginButton: 'Masuk',
    loginWait: 'Logging in, please wait',
    ces: 'CSE',
    emp: 'EMP',
    basicLoding: 'Pemuatan sistem',
    basictxLoading: 'Masuk, silakan tunggu',
    title: 'CSE EMP Pemuatan sistem',  
    account: 'Akun',
    haveAccount: 'Belum punya akun?',  
    info: 'Platform Pengembangan Organisasi Tingkat Tinggi BladeX',  
    tenantId: 'Tenant',  
    username: 'Username',  
    password: 'Password',  
    wechat: 'WeChat',  
    qq: 'QQ',  
    github: 'GitHub',  
    gitee: 'Gitee',  
    phone: 'Silakan masukkan nomor telepon',  
    code: 'Masukkan kode verifikasi',  
    submit: 'Login',  
    register: 'Register',  
    userLogin: 'Login dengan username dan password',  
    phoneLogin: 'Login dengan nomor telepon',  
    thirdLogin: 'Login dengan layanan pihak ketiga',  
    ssoLogin: 'SSO Login',  
    msgText: 'Kirim kode verifikasi',  
    msgSuccess: 'Kode verifikasi telah dikirim',  
  },  
  navbar: {  
    info: 'informasi',
    logOut: 'Logout',  
    userinfo: 'Info Pengguna',  
    switchDept: 'Ganti Departemen',  
    dashboard: 'Dashboard',  
    lock: 'Lock Screen',  
    bug: 'Tidak Ada Bug',  
    bugs: 'Bug',  
    screenfullF: 'Exit Fullscreen',  
    screenfull: 'Fullscreen',  
    language: 'Bahasa',  
    notice: 'Pemberitahuan',  
    theme: 'Tema',  
    color: 'Ganti Warna',  
  },  
  tagsView: {  
    search: 'Search',  
    menu: 'Lebih Banyak',  
    clearCache: 'Hapus Cache',  
    closeOthers: 'Tutup Lainnya',  
    closeAll: 'Tutup Semua',  
  },
  mBtn: {
    addSub: 'Tambahkan sub-item',
    dictConfig: 'Dict Config'
  },
  theader: {
    measuringPoint: 'titik pengukuran',
    name: 'nama',
    realTimeValue: 'nilai waktu nyata',
    unit: 'satuan',
    updateTime: 'Perbarui waktu',
    storage: 'Penyimpanan (menit)',
    alerts: 'Alarm',
    operate: 'beroperasi',
    project: 'proyek',
    area: 'daerah',
    detailAddress: 'Alamat lengkap',
    protocol: 'protokol',
    correspondenceAddress: 'Alamat korespondensi',
    dataTimeout: 'Batas waktu data habis (menit)',
    serialNumber: 'nomor seri',
    deviceId: 'ID Perangkat',
    gatewayId: 'ID gerbang',
    gatewayName: 'Nama gerbang',
    serialPortAddress: 'Alamat port serial',
    modelId: 'ID Model',
    creationTime: 'waktu penciptaan',
    updater: 'Pembaru',
    dataEncoding: 'Pengkodean data',
    fourShakeAttributes: 'Empat atribut goyang',
    storage: 'Penyimpanan (menit)',
    storageClass: 'kelas penyimpanan',
    alarmTime: 'Waktu alarm',
    recoveryTime: 'waktu pemulihan',
    alarmLevel: 'Tingkat alarm',
    alarmContent: 'Konten alarm',
    reportName: 'Nama laporan',
    reportTime: 'Waktu laporan',
    equipmentFailureRate: 'Tingkat kegagalan peralatan',
    score: 'skor',
    healthStatus: 'status kesehatan',
    roleName: 'Nama karakter',
    tenants: 'Penyewa milik',
    roleAliaes: 'alias peran',
    roleSorting: 'Penyortiran peran',
    institutionName: 'Nama organisasi',
    fullNameOfOrganization: 'Nama lengkap organisasi',
    institutionType: 'Jenis institusi',
    sorting: 'menyortir',
    loginAccount: 'Masuk akun',
    userName: 'Nama belakang',
    role: 'Peran',
    department: 'Departemen',
    userPlatform: 'Platform pengguna',
    potitionType: 'Jenis posisi',
    positionNo: 'Nomor posisi',
    potitionTitle: 'Judul pekerjaan',
    potitionSorting: 'Penyortiran posisi',
    dictionaryNumber: 'nomor kamus',
    dictionaryName: 'Nama kamus',
    dictionarySorting: 'Sortir kamus',
    archive: 'Segel',
    menuName: 'Nama menu',
    rutingAddress: 'alamat perutean',
    menuIcon: 'ikon menu',
    menuAliases: 'alias menunya',
    menuNo: 'Nomor menu',
    menuSorting: 'Penyortiran menu',
    tenantId: 'ID Penyewa',
    tenantName: 'Nama penyewa',
    contact: 'Kontak person',
    contactNumber: 'Nomor kontak',
    accountLimit: 'Batas akun',
    expirationTime: 'Waktu kedaluwarsa',
    bindDomainName: 'Ikat nama domain', 
    projectArea: 'Area Proyek',
    reportAttributes: 'Empat properti pelaporan',
    description: 'menggambarkan',
    caculateFactor: 'faktor perhitungan',
    dataInfo: 'Informasi data',
  }
};
